/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/common-utils';

import { Dropdown } from '@zapier/design-system-revenue/src/components/other';
import { useCurrencies } from '@zapier/design-system-revenue/src/hooks';

import { FlagIcon } from './FlagIcon';

const rootStyles = css`
  width: 143px;
`;

/**
 * A dropdown that allows the user to select the currency in which
 * pricing information is displayed.
 */
export const CurrencyDropdown = () => {
  const {
    isLoading,
    currencies: options,
    onSelectCurrency,
    selectedCurrency,
    error,
  } = useCurrencies();

  // Don't show if loading or error
  if (isLoading || error) {
    return null;
  }

  return (
    <div css={rootStyles}>
      <Dropdown
        ariaLabel="Currency"
        getLabelForSelectedItem={item => `${item.name} ${item.symbol}`}
        initialSelectedItem={selectedCurrency}
        items={options}
        menuAriaLabel="List of currencies"
        onChange={onSelectCurrency}
        placeholder="Choose a currency..."
        renderIcon={item => {
          return !!item && <FlagIcon name={item.icon} width={24} />;
        }}
      />
    </div>
  );
};
